module.exports = "https://static.energy5.com/_next/static/images/headerLedImage-c9163e903ef409302172d15404aea7b2.png";